import React, { useState,useEffect } from "react";
import { addSyllabus, deleteSyllabus } from "../../api/api";
import { useGlobalData } from '../../context/GlobalDataContext';
import "./AdminPanel.css";

function SyllabusAdminPanel() {
  const { threeTable = {}, fetchThreeTable } = useGlobalData();
  const jobs = threeTable.jobs || [];
  const syllabuses = threeTable.syllabuses || [];
  const [formData, setFormData] = useState({
    jobSlug: ""
  });

  useEffect(() => {
    if (!threeTable?.jobs?.length || !threeTable?.syllabuses?.length) {
      fetchThreeTable();
    }
  }, [threeTable?.jobs?.length, threeTable?.syllabuses?.length, fetchThreeTable]);

  // Role check for superadmin only
  const role = localStorage.getItem('role');
 

  // Data comes from context

   if (role !== 'superadmin') {
    return <div style={{ color: 'red', textAlign: 'center', marginTop: '2rem' }}>Access denied: Superadmin only</div>;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    await addSyllabus(formData);
    alert("Syllabus added!");
    setFormData({ jobSlug: "" });
    await fetchThreeTable(); // Refresh syllabuses after addition
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this syllabus?")) {
      await deleteSyllabus(id);
      alert("Syllabus deleted!");
      await fetchThreeTable(); // Refresh syllabuses after deletion
    }
  };

  const getJobTitle = (jobSlug) => jobs.find((job) => job.slug === jobSlug)?.title || jobSlug;
  const filteredSyllabuses = (syllabuses || []).slice().filter((syllabus) => !formData.jobSlug || syllabus.jobSlug === formData.jobSlug);

  return (
    <div className="resource-admin-panel resource-admin-panel--emerald">
      <div className="resource-admin-panel__header">
        <div>
          <h2 className="resource-admin-panel__heading">Syllabus Admin Panel</h2>
          <p className="resource-admin-panel__subtext">Syllabus records ke liye same polished workflow diya gaya hai, jisme save, review, live preview aur delete actions ek clean layout me milte hain.</p>
        </div>
        <div className="resource-admin-panel__pill">Syllabus</div>
      </div>

      <form className="resource-admin-panel__form" onSubmit={handleSubmit}>
        <div className="resource-admin-panel__field">
          <label className="resource-admin-panel__label">Select Job</label>
          <p className="resource-admin-panel__hint">Selected job ke liye syllabus record save hoga.</p>
          <select
            className="resource-admin-panel__select"
          value={formData.jobSlug}
          onChange={(e) => setFormData({ ...formData, jobSlug: e.target.value })}
        >
          <option value="">Select Job</option>
          {jobs.map((job) => (
            <option key={job._id} value={job.slug}>
              {job.title} ({job.slug})
            </option>
          ))}
        </select>
        </div>
        <button className="resource-admin-panel__submit" type="submit">Add Syllabus</button>
      </form>

      <div className="resource-admin-panel__section">
        <div className="resource-admin-panel__section-top">
          <div>
            <h3 className="resource-admin-panel__section-title">Saved Syllabus Entries</h3>
            <p className="resource-admin-panel__section-meta">{filteredSyllabuses.length} items {formData.jobSlug ? `for ${formData.jobSlug}` : "across all jobs"}</p>
          </div>
        </div>

        {filteredSyllabuses.length === 0 ? (
          <p className="resource-admin-panel__empty">Abhi selected filter ke liye koi syllabus entry nahi hai.</p>
        ) : (
          <div className="resource-admin-panel__list">
            {filteredSyllabuses.slice(0, 15).map((syllabus) => {
              // Status badge logic
              let status = (syllabus.status || '').toLowerCase();
              let statusLabel = status === 'approved' ? 'Approved' : 'Pending';
              let statusColor = status === 'approved' ? '#43a047' : '#fbc02d';
              let statusBg = status === 'approved' ? '#e8f5e9' : '#fffde7';
              let statusTextColor = status === 'approved' ? '#2e7d32' : '#b26a00';
              return (
                <div key={syllabus._id} className="resource-admin-panel__item">
                  <div>
                    <p className="resource-admin-panel__item-title">{getJobTitle(syllabus.jobSlug)}</p>
                    <p className="resource-admin-panel__item-subtitle">Slug: {syllabus.jobSlug}</p>
                    <span
                      style={{
                        display: 'inline-block',
                        padding: '2px 12px',
                        borderRadius: '12px',
                        fontWeight: 600,
                        fontSize: 13,
                        backgroundColor: statusBg,
                        color: statusTextColor,
                        border: `1.5px solid ${statusColor}`,
                        marginTop: 2
                      }}
                    >
                      {statusLabel}
                    </span>
                  </div>
                  <div className="resource-admin-panel__actions syllabus-admin-panel__actions-responsive">
                    <a
                      href={`/mform/${syllabus.jobSlug}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="resource-admin-panel__link"
                    >
                      View Syllabus
                    </a>
                    <button
                      type="button"
                      className="resource-admin-panel__delete"
                      onClick={() => handleDelete(syllabus._id)}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default SyllabusAdminPanel;
